import '../../assets/index16.css';var B = Object.defineProperty, D = Object.defineProperties;
var j = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var f = (t, e, o) => e in t ? B(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o, r = (t, e) => {
  for (var o in e || (e = {}))
    v.call(e, o) && f(t, o, e[o]);
  if (a)
    for (var o of a(e))
      x.call(e, o) && f(t, o, e[o]);
  return t;
}, C = (t, e) => D(t, j(e));
var g = (t, e) => {
  var o = {};
  for (var n in t)
    v.call(t, n) && e.indexOf(n) < 0 && (o[n] = t[n]);
  if (t != null && a)
    for (var n of a(t))
      e.indexOf(n) < 0 && x.call(t, n) && (o[n] = t[n]);
  return o;
};
import { jsxs as m, jsx as i } from "react/jsx-runtime";
import { Button as d } from "../Button/index.js";
import { Modal as A } from "../Modal/index.js";
import { forwardRef as N } from "react";
import { T } from "../../Title-D_D6eyDg.js";
const b = "Dialog-module__buttonContainer___Lv2Ty", R = "Dialog-module__textContainer___mvqPK", q = "Dialog-module__title___05jRA", _ = {
  buttonContainer: b,
  textContainer: R,
  title: q
}, F = N((w, y) => {
  var u = w, {
    buttonProps: t,
    children: e,
    icon: o,
    size: n = "360px",
    title: h
  } = u, p = g(u, [
    "buttonProps",
    "children",
    "icon",
    "size",
    "title"
  ]);
  let l, s, c;
  return Array.isArray(t) ? [c, s, l] = t.slice().reverse() : c = t, /* @__PURE__ */ m(
    A,
    C(r({
      ref: y,
      size: n
    }, p), {
      children: [
        o,
        /* @__PURE__ */ m("div", { className: _.textContainer, children: [
          /* @__PURE__ */ i(T, { className: _.title, children: h }),
          e
        ] }),
        /* @__PURE__ */ m("div", { className: _.buttonContainer, children: [
          l && /* @__PURE__ */ i(d, r({ variant: "secondary" }, l)),
          s && /* @__PURE__ */ i(d, r({ variant: "secondary" }, s)),
          /* @__PURE__ */ i(d, r({ variant: "accent", "data-autofocus": !0 }, c))
        ] })
      ]
    })
  );
});
export {
  F as Dialog
};
